import { type SegmentedControlOption } from '@air/component-segmented-control';

import { type ShortUrlProps } from '~/components/SharePrivateCollectionModal/types';

export const PERMISSION_OPTION_HIDE: SegmentedControlOption = {
  label: 'Hide',
  value: 'hide',
  id: 'hide',
  tooltip: 'Hide',
};

export const PERMISSION_OPTION_READ_ONLY: SegmentedControlOption = {
  label: 'Read only',
  value: 'read-only',
  id: 'read-only',
  tooltip: 'Read only',
};

export const PERMISSION_OPTION_ALLOW: SegmentedControlOption = {
  label: 'Allow',
  value: 'allow',
  id: 'allow',
  tooltip: 'Allow',
};

export const DEFAULT_SHORT_URL_PROPS: ShortUrlProps = {
  disabled: false,
  passcode: null,
  expirationDate: null,
  permissions: {
    asset: {
      canViewOriginal: false,
      canViewAllVersions: false,
      canManageDiscussions: false,
      canViewDiscussions: false,
    },
    customField: {
      canView: false,
      canManageApplications: false,
    },
    canvas: {
      canViewChatHistory: false,
    },
  },
};
